import { productAvailabilityStyles as styles } from "@iewc/Overrides/Components/ProductAvailability";
import { css } from "styled-components";

styles.messageGridItem = {
    ...styles.messageGridItem,
    css: css`
        ${styles.messageGridItem?.css}
        flex-wrap: wrap;
    `,
};

styles.availabilityTooltipWrapper = {
    css: css`
        display: inline-flex;
        flex-direction: column;
        text-align: left;
        text-wrap: wrap;
    `,
};

styles.availabilityTooltipTitle = {
    variant: "legend",
    forwardAs: "span",
    weight: 600,
};

styles.availabilityTooltipContent = {
    variant: "legend",
    forwardAs: "span",
    css: css`
        word-wrap: break-word;
        white-space: pre-wrap;
        word-break: break-word;
    `,
};
